import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  providerCheckoutContentService,
  ProviderCheckoutContentRequestError,
} from '@/services/provider/checkout-content.service';
import type {
  ProviderCheckoutContentSettings,
  UpdateProviderCheckoutContentInput,
} from '@/types/provider-checkout-content';

export const providerCheckoutContentKeys = {
  all: ['provider', 'checkout-content'] as const,
  detail: () => [...providerCheckoutContentKeys.all, 'detail'] as const,
  public: () => [...providerCheckoutContentKeys.all, 'public'] as const,
};

export function useProviderCheckoutContentSettings(enabled = true) {
  return useQuery<ProviderCheckoutContentSettings, ProviderCheckoutContentRequestError>({
    queryKey: providerCheckoutContentKeys.detail(),
    queryFn: () => providerCheckoutContentService.getSettings(),
    enabled,
  });
}

export function useUpdateProviderCheckoutContentSettings() {
  const queryClient = useQueryClient();

  return useMutation<
    ProviderCheckoutContentSettings,
    ProviderCheckoutContentRequestError,
    UpdateProviderCheckoutContentInput
  >({
    mutationFn: (input) => providerCheckoutContentService.updateSettings(input),
    onSuccess: (settings) => {
      queryClient.setQueryData(providerCheckoutContentKeys.detail(), settings);
    },
  });
}

export function usePublicProviderCheckoutContent(enabled = true) {
  return useQuery<ProviderCheckoutContentSettings | null, ProviderCheckoutContentRequestError>({
    queryKey: providerCheckoutContentKeys.public(),
    queryFn: () => providerCheckoutContentService.getPublicCopy(),
    enabled,
    retry: false,
  });
}
